export default __webpack_public_path__ + "static/lunar-chinese-new-year-2019-celebrations-around-the-world-4afaef2e30cefe8defb8c893385db8a4.jpg";